import { CARD_TYPES } from '../../../constants/CardTypes';

interface PlaceCardCustomization {
  type: string;
  should_print_guest_names: boolean;
  should_print_table_names: boolean;
}

export const placeCardFilter = <T extends PlaceCardCustomization>(
  tag: string,
  customization: T
): boolean => {
  const {
    type,
    should_print_guest_names: shouldPrintGuestNames,
    should_print_table_names: shouldPrintTableNames,
  } = customization;

  if (type !== CARD_TYPES.place) return true;

  if (tag === 'PLACE_CARD_GUEST') return shouldPrintGuestNames;

  if (tag === 'PLACE_CARD_TABLE' || tag === 'PLACE_CARD_STATIC_TABLE_ELEMENT')
    return shouldPrintTableNames;

  return true;
};
